(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-images-with-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('x-article-images-with-text-carousel')) {
		customElements.define('x-article-images-with-text-carousel', class extends HTMLElement {
			connectedCallback() {
				this.carousel = this.querySelector('x-inline-carousel');
				this.view = this.querySelector('[data-inline-carousel-element="view"]');
				this.track = this.querySelector('[data-inline-carousel-element="track"]');
				this.slides = Array.from(this.track?.children || []);
				this.radios = Array.from(this.querySelectorAll('[data-carousel-pagination-element="radio"]'));
				this.navPrev = this.querySelector('[data-article-images-with-text-slider-element="nav-prev"]');
				this.navNext = this.querySelector('[data-article-images-with-text-slider-element="nav-next"]');
				this.itemsCount = this.radios.length;
				this.currentIndex = 0;
				this.dragStartX = 0;
				this.dragDelta = 0;
				this.dragging = false;

				this.radios.forEach(radio => {
					radio.addEventListener('change', () => {
						this.setPosition(Number(radio.value));
					});
				});

				this.navPrev?.addEventListener('click', event => {
					event.preventDefault();
					this.setPosition(this.currentIndex - 1);
				});

				this.navNext?.addEventListener('click', event => {
					event.preventDefault();
					this.setPosition(this.currentIndex + 1);
				});

				this.querySelectorAll('a[href="#article-modal-close"]').forEach(link => {
					link.addEventListener('click', event => {
						event.preventDefault();
						document.querySelector('[data-article-modal]')?.setAttribute('hidden', '');
						document.body.classList.remove('blog-modal-open');
					});
				});

				this.view?.addEventListener('pointerdown', event => this.startDrag(event));
				this.view?.addEventListener('pointermove', event => this.moveDrag(event));
				this.view?.addEventListener('pointerup', event => this.endDrag(event));
				this.view?.addEventListener('pointercancel', event => this.endDrag(event));
				this.view?.addEventListener('dragstart', event => event.preventDefault());
				this.updateState();
			}

			setPosition(index) {
				if (!this.carousel || this.itemsCount === 0) {
					return;
				}

				this.currentIndex = Math.max(0, Math.min(index, this.itemsCount - 1));
				this.carousel.currentItem = this.currentIndex;
				this.carousel.style.setProperty('--inline-carousel-current-index', String(this.currentIndex));

				if (window.matchMedia('(max-width: 991px)').matches) {
					this.slides[this.currentIndex]?.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',
						inline: 'start'
					});
				}

				this.updateState();
			}

			updateState() {
				this.radios.forEach((radio, index) => {
					radio.checked = index === this.currentIndex;
				});

				this.carousel?.classList.toggle('inline-carousel--disable-prev', this.currentIndex <= 0);
				this.carousel?.classList.toggle('inline-carousel--disable-next', this.currentIndex >= this.itemsCount - 1);

				if (this.navPrev) {
					this.navPrev.disabled = this.currentIndex <= 0;
				}

				if (this.navNext) {
					this.navNext.disabled = this.currentIndex >= this.itemsCount - 1;
				}
			}

			startDrag(event) {
				if (event.pointerType !== 'mouse' || event.button !== 0 || this.itemsCount <= 1) {
					return;
				}

				if (event.target.closest('button, label, input')) {
					return;
				}

				this.dragging = true;
				this.dragStartX = event.clientX;
				this.dragDelta = 0;
				this.view.setPointerCapture(event.pointerId);
				this.view.classList.add('article-images-with-text__view--dragging');
			}

			moveDrag(event) {
				if (!this.dragging || !this.track) {
					return;
				}

				this.dragDelta = event.clientX - this.dragStartX;
				const moveSize = this.getMoveSize();
				const baseOffset = this.currentIndex * -1 * moveSize;
				this.track.style.transition = 'none';
				this.track.style.transform = `translateX(${baseOffset + this.dragDelta}px)`;
				event.preventDefault();
			}

			endDrag(event) {
				if (!this.dragging || !this.track) {
					return;
				}

				this.dragging = false;
				this.view.releasePointerCapture(event.pointerId);
				this.view.classList.remove('article-images-with-text__view--dragging');
				this.track.style.transition = '';
				this.track.style.transform = '';

				const threshold = Math.min(120, this.getMoveSize() * 0.2);
				if (Math.abs(this.dragDelta) >= threshold) {
					const direction = this.dragDelta > 0 ? -1 : 1;
					this.setPosition(this.currentIndex + direction);
				} else {
					this.setPosition(this.currentIndex);
				}

				this.dragDelta = 0;
			}

			getMoveSize() {
				const firstSlide = this.track?.firstElementChild;
				const slideWidth = firstSlide?.getBoundingClientRect().width || this.view?.getBoundingClientRect().width || 0;
				const trackStyle = window.getComputedStyle(this.track);
				const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;

				return slideWidth + gap;
			}
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-images-with-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('stacked-images-gallery')) {
		customElements.define('stacked-images-gallery', class extends HTMLElement {
			connectedCallback() {
				this.cards = Array.from(this.querySelectorAll('[data-stacked-gallery-element="card"]'));
				this.captions = Array.from(this.querySelectorAll('[data-stacked-gallery-element="caption"]'));
				this.activeIndex = 0;
				this.autoplayDelay = 5000;
				this.isVisible = false;
				this.onClick = this.handleClick.bind(this);
				this.onKeydown = this.handleKeydown.bind(this);
				this.onBlockSelect = this.handleBlockSelect.bind(this);
				this.addEventListener('click', this.onClick);
				this.addEventListener('keydown', this.onKeydown);
				document.addEventListener('shopify:block:select', this.onBlockSelect);
				this.observeVisibility();
				this.render();
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick);
				this.removeEventListener('keydown', this.onKeydown);
				document.removeEventListener('shopify:block:select', this.onBlockSelect);
				this.visibilityObserver?.disconnect();
				this.clearAutoplay();
			}

			handleClick(event) {
				const card = event.target.closest('[data-stacked-gallery-element="card"]');
				if (!card || !this.contains(card)) return;
				const index = Number(card.dataset.index);
				this.activate(index === this.activeIndex ? this.activeIndex + 1 : index, true);
			}

			handleKeydown(event) {
				if (!event.target.closest('[data-stacked-gallery-element="card"]')) return;
				const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
				if (!keys.includes(event.key)) return;
				event.preventDefault();
				if (event.key === 'Home') this.activate(0, true);
				if (event.key === 'End') this.activate(this.cards.length - 1, true);
				if (event.key === 'ArrowRight' || event.key === 'ArrowDown') this.activate(this.activeIndex + 1, true);
				if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') this.activate(this.activeIndex - 1, true);
			}

			handleBlockSelect(event) {
				const card = event.target.closest('[data-stacked-gallery-element="card"]');
				if (!card || !this.contains(card)) return;
				this.activate(Number(card.dataset.index));
			}

			activate(index, moveFocus = false) {
				if (!this.cards.length) return;
				this.activeIndex = (index + this.cards.length) % this.cards.length;
				this.render();
				this.restartAutoplay();
				if (moveFocus) this.cards[this.activeIndex].focus();
			}

			observeVisibility() {
				this.visibilityObserver = new IntersectionObserver((entries) => {
					this.isVisible = entries.some((entry) => entry.isIntersecting);
					if (this.isVisible) this.restartAutoplay();
					else this.clearAutoplay();
				}, { threshold: 0.25 });
				this.visibilityObserver.observe(this);
			}

			clearAutoplay() {
				window.clearTimeout(this.autoplayTimer);
				this.autoplayTimer = null;
			}

			restartAutoplay() {
				this.clearAutoplay();
				if (!this.isVisible || this.cards.length < 2) return;
				this.autoplayTimer = window.setTimeout(() => this.activate(this.activeIndex + 1), this.autoplayDelay);
			}

			render() {
				const length = this.cards.length;
				this.cards.forEach((card, index) => {
					const depth = (index - this.activeIndex + length) % length;
					const visibleDepth = Math.min(depth, 4);
					card.style.setProperty('--stack-y', `${(4 - visibleDepth) * 0.6}rem`);
					card.style.setProperty('--stack-scale', 1 - visibleDepth * 0.018);
					card.style.setProperty('--stack-opacity', 1 - visibleDepth * 0.11);
					card.style.setProperty('--stack-tilt', `${visibleDepth * 0.8}deg`);
					card.style.setProperty('--stack-z', length - depth);
					card.classList.toggle('is-active', depth === 0);
					card.classList.toggle('is-concealed', depth > 4);
					card.setAttribute('aria-pressed', depth === 0 ? 'true' : 'false');
					card.tabIndex = depth === 0 ? 0 : -1;
				});
				this.captions.forEach((caption, index) => {
					const active = index === this.activeIndex;
					caption.classList.toggle('is-active', active);
					caption.setAttribute('aria-hidden', active ? 'false' : 'true');
				});
			}
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-youtube-videos-with-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('stacked-youtube-gallery')) {
		customElements.define('stacked-youtube-gallery', class extends HTMLElement {
			connectedCallback() {
				if (this.initialized) return;
				this.initialized = true;
				this.initialize();
			}

			async initialize() {
				this.cards = Array.from(this.querySelectorAll('[data-stacked-youtube-element="card"]'));
				this.cycles = Array.from(this.querySelectorAll('[data-stacked-youtube-element="cycle"]'));
				this.playButtons = Array.from(this.querySelectorAll('[data-stacked-youtube-element="play"]'));
				this.captions = Array.from(this.querySelectorAll('[data-stacked-youtube-element="caption"]'));
				this.iframe = this.querySelector('[data-stacked-youtube-element="iframe"]');
				this.activeIndex = 0;
				this.autoplayDelay = 5000;
				this.isVisible = false;
				this.onClick = this.handleClick.bind(this);
				this.onKeydown = this.handleKeydown.bind(this);
				this.onBlockSelect = this.handleBlockSelect.bind(this);
				this.addEventListener('click', this.onClick);
				this.addEventListener('keydown', this.onKeydown);
				document.addEventListener('shopify:block:select', this.onBlockSelect);
				await customElements.whenDefined('x-modal');
				this.modal = this.querySelector('x-modal');
				this.modal.beforeClose = () => this.stopVideo();
				this.modal.querySelector('dialog')?.addEventListener('close', () => this.stopVideo());
				this.observeVisibility();
				this.render();
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick);
				this.removeEventListener('keydown', this.onKeydown);
				document.removeEventListener('shopify:block:select', this.onBlockSelect);
				this.visibilityObserver?.disconnect();
				this.clearAutoplay();
			}

			handleClick(event) {
				const playButton = event.target.closest('[data-stacked-youtube-element="play"]');
				if (playButton && this.contains(playButton)) {
					this.openVideo(playButton);
					return;
				}
				const cycleButton = event.target.closest('[data-stacked-youtube-element="cycle"]');
				if (!cycleButton || !this.contains(cycleButton)) return;
				const index = Number(cycleButton.dataset.index);
				this.activate(index === this.activeIndex ? this.activeIndex + 1 : index, true);
			}

			handleKeydown(event) {
				if (!event.target.closest('[data-stacked-youtube-element="cycle"]')) return;
				const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
				if (!keys.includes(event.key)) return;
				event.preventDefault();
				if (event.key === 'Home') this.activate(0, true);
				if (event.key === 'End') this.activate(this.cards.length - 1, true);
				if (event.key === 'ArrowRight' || event.key === 'ArrowDown') this.activate(this.activeIndex + 1, true);
				if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') this.activate(this.activeIndex - 1, true);
			}

			handleBlockSelect(event) {
				const card = event.target.closest('[data-stacked-youtube-element="card"]');
				if (!card || !this.contains(card)) return;
				this.activate(Number(card.dataset.index));
			}

			activate(index, moveFocus = false) {
				if (!this.cards.length) return;
				this.activeIndex = (index + this.cards.length) % this.cards.length;
				this.render();
				this.restartAutoplay();
				if (moveFocus) this.cycles[this.activeIndex].focus();
			}

			observeVisibility() {
				this.visibilityObserver = new IntersectionObserver((entries) => {
					this.isVisible = entries.some((entry) => entry.isIntersecting);
					if (this.isVisible) this.restartAutoplay();
					else this.clearAutoplay();
				}, { threshold: 0.25 });
				this.visibilityObserver.observe(this);
			}

			clearAutoplay() {
				window.clearTimeout(this.autoplayTimer);
				this.autoplayTimer = null;
			}

			restartAutoplay() {
				this.clearAutoplay();
				if (!this.isVisible || this.cards.length < 2) return;
				this.autoplayTimer = window.setTimeout(() => this.activate(this.activeIndex + 1), this.autoplayDelay);
			}

			render() {
				const length = this.cards.length;
				this.cards.forEach((card, index) => {
					const depth = (index - this.activeIndex + length) % length;
					const visibleDepth = Math.min(depth, 4);
					card.style.setProperty('--stack-y', `${(4 - visibleDepth) * 0.6}rem`);
					card.style.setProperty('--stack-scale', 1 - visibleDepth * 0.018);
					card.style.setProperty('--stack-opacity', 1 - visibleDepth * 0.11);
					card.style.setProperty('--stack-tilt', `${visibleDepth * 0.8}deg`);
					card.style.setProperty('--stack-z', length - depth);
					card.classList.toggle('is-active', depth === 0);
					card.classList.toggle('is-concealed', depth > 4);
				});
				this.cycles.forEach((cycle, index) => {
					const active = index === this.activeIndex;
					cycle.setAttribute('aria-pressed', active ? 'true' : 'false');
					cycle.tabIndex = active ? 0 : -1;
				});
				this.playButtons.forEach((button, index) => {
					button.tabIndex = index === this.activeIndex && !button.disabled ? 0 : -1;
				});
				this.captions.forEach((caption, index) => {
					const active = index === this.activeIndex;
					caption.classList.toggle('is-active', active);
					caption.setAttribute('aria-hidden', active ? 'false' : 'true');
				});
			}

			openVideo(button) {
				const videoId = button.dataset.videoId;
				if (!videoId || !this.modal || !this.iframe) return;
				this.iframe.title = button.dataset.videoTitle || 'YouTube';
				this.iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
				this.modal.open();
			}

			stopVideo() {
				if (this.iframe) this.iframe.src = 'about:blank';
			}
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-blog"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('x-video-blog')) {
		customElements.define('x-video-blog', class extends HTMLElement {
			connectedCallback() {
				if (this.initialized) return;
				this.initialized = true;
				this.initialize();
			}

			async initialize() {
				await customElements.whenDefined('x-modal');
				this.modal = this.querySelector('x-modal');
				this.iframe = this.querySelector('[data-video-blog-element="iframe"]');
				this.querySelectorAll('[data-video-blog-element="trigger"]').forEach((trigger) => {
					trigger.addEventListener('click', () => this.openVideo(trigger));
				});
				this.modal.beforeClose = () => this.stopVideo();
				this.modal.querySelector('dialog')?.addEventListener('close', () => this.stopVideo());
			}

			openVideo(trigger) {
				const videoId = trigger.dataset.videoId;
				if (!videoId || !this.modal || !this.iframe) return;
				this.iframe.title = trigger.dataset.videoTitle || 'YouTube';
				this.iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
				this.modal.open();
			}

			stopVideo() {
				if (this.iframe) this.iframe.src = 'about:blank';
			}
		});
	}

  } catch(e) { console.error(e); }
})();
})();
